<template>
  <div class="rounded-lg shadow bg-white p-4">
    <div class="flex justify-between items-center mb-4">
      <div>
        <h2 class="font-bold text-xl">메뉴 관리</h2>
        <p class="text-gray-500 text-sm mt-1">대메뉴와 소메뉴를 트리 구조로 관리합니다.</p>
      </div>
      <Button :type="ButtonTypes.blue" label="대메뉴 추가" :onClick="() => openCreate(null)" />
    </div>

    <div v-for="menu in menus" :key="menu.id" class="border rounded mb-3">
      <div class="flex justify-between items-center p-3 bg-gray-100">
        <div>
          <span class="font-bold">{{ menu.name }}</span>
          <span class="text-gray-500 ml-3">{{ menu.routeName }} · {{ menu.path || '그룹' }} · 순서 {{ menu.sortOrder }}</span>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-primary mr-2" @click="openCreate(menu)">소메뉴 추가</button>
          <button class="btn btn-sm btn-outline-secondary mr-2" @click="openEdit(menu)">변경</button>
          <button class="btn btn-sm btn-outline-danger" @click="remove(menu)">삭제</button>
        </div>
      </div>
      <div v-for="child in menu.children" :key="child.id" class="flex justify-between items-center py-3 px-4 ml-6 border-t">
        <div>
          <span>└ {{ child.name }}</span>
          <span class="text-gray-500 ml-3">{{ child.routeName }} · {{ child.path }} · 순서 {{ child.sortOrder }}</span>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-secondary mr-2" @click="openEdit(child)">변경</button>
          <button class="btn btn-sm btn-outline-danger" @click="remove(child)">삭제</button>
        </div>
      </div>
    </div>

    <b-modal v-model="modalOpen" :title="editingId ? '메뉴 변경' : '메뉴 추가'" hide-footer>
      <b-form-group label="메뉴명"><b-form-input v-model="form.name" /></b-form-group>
      <b-form-group label="라우트 이름"><b-form-input v-model="form.routeName" placeholder="예: Staffs" /></b-form-group>
      <b-form-group label="경로"><b-form-input v-model="form.path" placeholder="예: /staffs (그룹 메뉴는 공백)" /></b-form-group>
      <b-form-group label="상위 메뉴">
        <b-form-select v-model="form.parentId" :options="parentOptions" />
      </b-form-group>
      <b-form-group label="노출 순서"><b-form-input v-model.number="form.sortOrder" type="number" /></b-form-group>
      <div class="text-right"><button class="btn btn-primary" @click="save">저장</button></div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api/api'
import Button from '@/components/Button.vue'
import {ButtonTypes} from '@/util/enums'

export default {
  components: {Button},
  computed: {
    ButtonTypes() { return ButtonTypes },
    parentOptions() {
      return [
        {value: null, text: '대메뉴'},
        ...this.menus.filter((menu) => menu.id !== this.editingId).map((menu) => ({value: menu.id, text: menu.name})),
      ]
    },
  },
  data() {
    return {
      menus: [], modalOpen: false, editingId: null,
      form: {name: '', routeName: '', path: '', parentId: null, sortOrder: 0},
    }
  },
  mounted() { this.load() },
  methods: {
    load() { api.adminMenu.list().then((response) => { this.menus = response.data }) },
    openCreate(parent) {
      this.editingId = null
      this.form = {name: '', routeName: '', path: '', parentId: parent?.id || null, sortOrder: parent ? parent.sortOrder + 1 : 0}
      this.modalOpen = true
    },
    openEdit(menu) {
      this.editingId = menu.id
      this.form = {name: menu.name, routeName: menu.routeName, path: menu.path, parentId: menu.parentId, sortOrder: menu.sortOrder}
      this.modalOpen = true
    },
    save() {
      const request = this.editingId
        ? api.adminMenu.update(this.editingId, this.form)
        : api.adminMenu.create(this.form)
      request.then(() => { this.modalOpen = false; this.load(); window.dispatchEvent(new Event('admin-menus-updated')) })
    },
    remove(menu) {
      if (!confirm(`${menu.name} 메뉴${menu.children?.length ? '와 하위 메뉴를 모두' : '를'} 삭제하시겠습니까?`)) return
      api.adminMenu.delete(menu.id).then(() => { this.load(); window.dispatchEvent(new Event('admin-menus-updated')) })
    },
  },
}
</script>
